import moment from 'moment';
import {
  i18n
} from './vue-i18n';
import { message } from './resetMessage.js';
import { MessageBox } from 'element-ui';
import store from "../store";
export default {
  getData(time) {
    return moment(time).format('YYYY-MM-DD');
  },
  confirm(key, callback, params, cancelBack) {
    const tip = this.i18nF(key, params);
    MessageBox.confirm(tip, i18n.t('common.tips'), {
      type: 'warning'
    }).then(async () => {
      callback();
    }).catch(() => {
      if (cancelBack) {
        cancelBack();
      }
    });
  },
  matchData(list, key, list_key, return_key) {
    const has_list_key = list_key || 'id';
    const has_return_key = return_key || 'label';
    const item = list.find(t => t[has_list_key] === key);
    if (item) {
      return item[has_return_key];
    } return '';
  },
  i18nF(code, data) {
    let tips = i18n.t(code);
    if (data) {
      // eslint-disable-next-line guard-for-in
      for (const key in data) {
        tips = tips.replace(new RegExp(`{${key}}`, 'g'), data[key]);
      }
    }
    return tips;
  },
  containerToTop(num) {
    const el = '.content-wrapper';
    const myDiv = document.querySelector(el);
    myDiv.scrollTop = num || 0;
  },
  // 判断文件类型
  determineFileType(fileName, list) {
    const suffix = fileName.substring(fileName.lastIndexOf('.')); // 获取后缀
    const typeList = list || ['.png', '.jpg', '.JPG', '.jpeg'];
    const t = typeList.find(r => r === suffix.toLowerCase());
    // window.alert(fileName)
    if (t) {
      return true;
    }
    return false;
  },
  verifyMobilePhone() {
    // console.log('测试手机正则的封装方法');
    const mPattern =
      /^((13[0-9])|(14[5|7])|(17[0-9])|(16[0-9])|(19[0-9])|(15([0-9]))|(18[0-9])|(92[0-9])|(98[0-9]))\d{8}$/;
    return mPattern;
  },
  // 判断手机号
  isCorrectTel(mobile) {
    const mPattern = this.verifyMobilePhone();
    if (mPattern.test(mobile)) {
      return true;
    }
    return false;
  },
  currentScroll(callback) {
    const el = '.content-wrapper';
    const myDiv = document.querySelector(el);
    sessionStorage.setItem('content_wrapper_top', myDiv.scrollTop);
    if (callback) {
      callback(myDiv.scrollTop);
    }
  },
  initContentScroll(number) {
    const num = number || sessionStorage.getItem('content_wrapper_top');
    if (num) {
      this.containerToTop(num)
      sessionStorage.removeItem('content_wrapper_top');
    }
  },
  errTip(key, type) {
    message({
      message: i18n.t(key),
      type: type || 'error'
    })
  },
  exportOnUrl(url, type) {
    if (type === 'txt') {
        url= url.replace(/\\/g, '/');
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            // 获取文件blob数据并保存
            let fileName = this.getFileName(url);
            this.saveAs(xhr.response, fileName);
          }
        };
        xhr.send();
    } else {
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
  saveAs(data, name) {
    const urlObject = window.URL || window.webkitURL || window;
    const export_blob = new Blob([data]);
    let save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
    save_link.href = urlObject.createObjectURL(export_blob);
    save_link.download = name;
    save_link.click();
  },
  getFileName(url) {
    const num = url.lastIndexOf('/')+1
    let fileName = url.substring(num)
    //把参数和文件名分割开
    fileName = decodeURI(fileName.split("?")[0]);
    return fileName;
  },
  // 非gds零件
  notGDS(skuId) {
    const pattern = /^(GDS|WCN)(-[A-z0-9]+){2,}$/;
    return !pattern.test(skuId.toLocaleUpperCase());
  },
  pushStateFormat(pushState){
    const pushStateList = store.state.pushStateList;
    const item = pushStateList.find((i) => {return i.key === pushState})
    if (item) {
      return i18n.t(item.label)
    } return pushState
  },
}



// WEBPACK FOOTER //
// ./src/until/common.js